import { IngredientsEnum } from "../../scenes/BurgerScene";

// export enum IngredientsEnum{
//     Egg = 1,
//     Lettuce, 2
//     Cheese, 3
//     Tomato, 4

//     Patty, 5
//     BunBottom, 6
//     BunTop, 7
// }

export const recipes = {
    first: {ingredients: [6, 1, 3, 5, 4, 7]},
    short: [
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Patty, IngredientsEnum.Cheese, IngredientsEnum.BunTop]},
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Cheese, IngredientsEnum.Cheese, IngredientsEnum.Cheese, IngredientsEnum.BunTop]},
        {ingredients: [6, 1, 7]},// no patty
        {ingredients: [6, 1, 3, 7]},// no patty
        {ingredients: [6, 1, 5, 7]},
        {ingredients: [6, 4, 5, 7]},
        {ingredients: [6, 2, 3, 7]},// no patty
        {ingredients: [6, 5, 6, 7]},
        {ingredients: [6, 5, 7]},
        {ingredients: [6, 4, 2, 7]},// no patty
        {ingredients: [6, 1, 1, 7]}, // no patty
        {ingredients: [6, 1, 4, 7]}, // no patty
        {ingredients: [6, 4, 3, 7]}, // no patty
        {ingredients: [6, 1, 2, 1, 7]}, // no patty
        {ingredients: [6, 5, 2, 4, 7]},
        {ingredients: [6, 5, 3, 3, 7]},
        {ingredients: [6, 3, 2, 4, 7]},// no patty
        {ingredients: [6, 5, 5, 5, 7]},
        {ingredients: [6, 4, 2, 1, 7]},// no patty
        {ingredients: [6, 2, 4, 3, 7]},// no patty
        {ingredients: [6, 3, 6, 3, 7]},// no patty
        {ingredients: [6, 3, 2, 5, 7]},
        {ingredients: [6, 3, 6, 5,7]},// no patty
        {ingredients: [6, 4, 6, 1, 7]},// no patty
        {ingredients: [6, 2, 6, 5, 7]},
    ],
    normal: [
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Lettuce, IngredientsEnum.Patty, IngredientsEnum.Cheese, IngredientsEnum.Egg, IngredientsEnum.Tomato, IngredientsEnum.BunTop]},
        // {ingredients: [IngredientsEnum.BunBottom, IngredientsEnum.Patty, IngredientsEnum.Cheese, IngredientsEnum.BunBottom, IngredientsEnum.Patty, IngredientsEnum.Cheese,  IngredientsEnum.BunTop]},
        {ingredients: [6, 3, 5, 3, 5, 7]},
        {ingredients: [6, 2, 4, 1, 5, 7]},
        {ingredients: [6, 4, 2, 4, 2, 4, 7]},// no patty
        {ingredients: [6, 5, 1, 3, 5, 7]},
        {ingredients: [6, 4, 2, 3, 1, 5, 7]},
        {ingredients: [6, 1, 3, 1, 3, 1, 7]},// no patty
        {ingredients: [6, 1, 3, 5, 4, 7]},
        {ingredients: [6, 5, 2, 2, 2, 2, 7]},
        {ingredients: [6, 3, 5, 5, 2, 7]},
        {ingredients: [6, 3, 5, 6, 3, 5, 7]}, 
        {ingredients: [6, 2, 5, 6, 2, 5, 7]},
        {ingredients: [6, 2, 6, 5, 2, 7]},
        {ingredients: [6, 6, 1, 5, 3, 7]},
        {ingredients: [6, 5, 6, 5, 1, 7]},
        {ingredients: [6, 3, 1, 2, 5, 7]},
        {ingredients: [6, 3, 1, 3, 2, 7]}, // no patty
        {ingredients: [6, 5, 2, 1, 2, 7]},
    ],

    meme: [
        {ingredients: [6, 4, 1, 4, 1, 4, 7]},// no patty
        {ingredients: [6, 5, 5, 5, 5, 7]},
        {ingredients: [6, 6, 7]},// no patty
        {ingredients: [6, 3, 5]},
        {ingredients: [6, 4, 7]}, // no patty
        {ingredients: [2]},
        {ingredients: [6, 6, 6, 6, 7]},
        {ingredients: [3, 5, 3]},
        {ingredients: [5, 1, 5, 1, 5]},
        {ingredients: [5, 4, 5]},
    ];
}